import React from 'react';
import { FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import { getCurrency } from 'utils/currency';

const Price = ({
  value,
  hidden,
  altText,
  countryCode,
  displayCaption,
  ...otherProps
}) => {
  if (!hidden) {
    /* eslint-disable react/style-prop-object */
    const currency = getCurrency(countryCode);
    return (
      <React.Fragment>
        <FormattedNumber
          value={value}
          style="currency"
          currency={currency}
          currencyDisplay={'symbol'}
          {...otherProps}
        />
        {displayCaption && <span>*</span>}
      </React.Fragment>
    );
    /* eslint-enable react/style-prop-object */
  } else if (altText) {
    return altText;
  }
  return null;
};

Price.propTypes = {
  altText: PropTypes.string,
  countryCode: PropTypes.string,
  hidden: PropTypes.bool,
  showZero: PropTypes.bool,
  value: PropTypes.number,
  displayCaption: PropTypes.bool
};

Price.defaultProps = {
  hidden: true,
  showZero: false,
  displayCaption: false
};

export default Price;



// WEBPACK FOOTER //
// ./src/components/atoms/Price/Price.js